import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    error: {
        ...theme.typography.caption,
        color: theme.palette.error.main,
        marginTop: 3,
        marginRight: theme.spacing(2),
        marginBottom: 0,
        whiteSpace: 'pre-line',
    },
}));

export function ErrorSpanMessage(props) {
    const { message } = props;
    const classes = useStyles();
    return <span className={classes.error}>{message}</span>;
}

export default function ValidationError(props) {
    const { invalid, message } = props;
    return invalid ? <ErrorSpanMessage message={message} /> : null;
}
